/* eslint-disable @typescript-eslint/no-explicit-any */
import { Navigate, useLocation } from 'react-router-dom';
import { pathConstants } from '../constants';

export const ProtectedRoute = ({ children }: any) => {
  const location = useLocation();
  const accessToken = localStorage.getItem('accessToken'); 
  
  if (!accessToken) {
    // Lưu URL hiện tại (intended destination) vào localStorage
    // Sau khi login sẽ redirect về đây
    localStorage.setItem('intendedUrl', location.pathname + location.search);
    
    // Redirect to login page
    return <Navigate to={pathConstants.LOGIN} replace />;
  }
  
  return children;
};
